
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[city]/a/[product]",
      function () {
        return require("private-next-pages/c/[city]/a/[product].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[city]/a/[product]"])
      });
    }
  